import React from "react";

import { Jumbotron } from "./migration";

const defaultSteps = [
  {
    title: "Discovery and Audit",
    description:
      "I map your current workflow, pain points, and target outcomes so automation is tied to measurable business value.",
    icon: "fa-search",
  },
  {
    title: "Workflow Blueprint",
    description:
      "I design the end-to-end automation flow with triggers, approvals, exceptions, and data movement before build starts.",
    icon: "fa-sitemap",
  },
  {
    title: "Build and Integrate",
    description:
      "I implement the automation across your existing tools, APIs, and internal systems with clear progress updates.",
    icon: "fa-cogs",
  },
  {
    title: "Test and Rollout",
    description:
      "I validate edge cases and reliability, then roll out safely with monitoring so operations are not disrupted.",
    icon: "fa-rocket",
  },
  {
    title: "Handover and Support",
    description:
      "You get documentation, ownership, and post-launch support so your team can run and evolve the solution confidently.",
    icon: "fa-life-ring",
  },
];

const AutomationProcess = ({
  heading = "How I Deliver Your Automation Solution",
  subheading = "A clear, collaborative process from first call to long-term operational impact.",
  steps = defaultSteps,
}) => {
  return (
    <Jumbotron
      id="process"
      className="m-0 text-white"
      style={{
        backgroundColor: "rgb(15, 18, 24)",
        backgroundImage:
          "radial-gradient(circle at 8% 25%, rgba(76, 201, 240, 0.12), transparent 28%), radial-gradient(circle at 92% 35%, rgba(144, 190, 109, 0.12), transparent 30%)",
      }}
    >
      <div className="container py-5">
        <h2 className="display-4 text-center mb-3">{heading}</h2>
        <p
          className="lead text-center mx-auto mb-5"
          style={{ maxWidth: "760px", color: "rgba(255, 255, 255, 0.84)" }}
        >
          {subheading}
        </p>

        <div className="mx-auto" style={{ maxWidth: "860px" }}>
          {steps.map((step, index) => {
            const isLastStep = index === steps.length - 1;

            return (
              <React.Fragment key={`${step.title}-${index}`}>
                <div
                  className="p-4 rounded"
                  style={{
                    backgroundColor: "rgba(24, 28, 36, 0.9)",
                    border: "1px solid rgba(255, 255, 255, 0.14)",
                  }}
                >
                  <div className="d-flex align-items-center mb-3">
                    <span
                      className="d-inline-flex align-items-center justify-content-center me-3"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        background: "rgba(76, 201, 240, 0.2)",
                        border: "1px solid rgba(76, 201, 240, 0.45)",
                        color: "#fff",
                        fontWeight: 700,
                      }}
                    >
                      {index + 1}
                    </span>
                    <i
                      className={`fas ${step.icon}`}
                      style={{
                        color: "rgba(255, 255, 255, 0.78)",
                        fontSize: "1.05rem",
                      }}
                    />
                  </div>
                  <h3 className="h5 mb-2">{step.title}</h3>
                  <p
                    className="mb-0"
                    style={{ color: "rgba(255, 255, 255, 0.75)" }}
                  >
                    {step.description}
                  </p>
                </div>

                {!isLastStep && (
                  <div className="d-flex flex-column align-items-center py-3">
                    <i
                      className="fas fa-arrow-down"
                      style={{
                        color: "rgba(255, 255, 255, 0.58)",
                        fontSize: "1.2rem",
                      }}
                    />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </Jumbotron>
  );
};

export default AutomationProcess;
